import { EmojiEvents, Place } from "@mui/icons-material";
import AnimatedCounter from "../AnimatedCounter";

const StatsBanner = () => {
  return (
    <div className="bg-[#00539F] relative opacity-90 md:h-[40vh] w-full mt-56 h-[46vh]">
      <div className="bg-[url('assets/images/statsBg.jpeg')] object-cover h-full bg-cover bg-bottom opacity-10"></div>
      <div className="flex flex-col md:flex-row justify-evenly relative h-full top-[-100%] items-center font-HNmed font-medium md:text-4xl py-3">
        <div className="text-white flex flex-row items-center ">
          <Place sx={{ fontSize: { md: "60px", sm: "40px" } }} />
          <img src={require("../../assets/images/backSlash.png")} alt="" />
          <div className="flex flex-col">
            <span className="flex flex-row">
              <AnimatedCounter className="p-2" endValue={5} />
            </span>
            <div className="text-sm opacity-60">LOCATIONS</div>
          </div>
        </div>
        <div className="text-white flex flex-row items-center ">
          <img
            src={require("../../assets/images/bottleCap.png")}
            className="w-[40px] md:w-auto"
            alt=""
          />
          <img src={require("../../assets/images/backSlash.png")} alt="" />
          <div className="flex flex-col">
            <span className="flex flex-row">
              <AnimatedCounter className="p-2" endValue={60} />
              &nbsp;+
            </span>
            <div className="text-sm opacity-60">PRODUCTS</div>
          </div>
        </div>
        <div className="text-white flex flex-row items-center ">
          <img
            src={require("../../assets/images/deskInfo.png")}
            alt="deskinfoImage"
            className="w-[40px] md:w-auto"
          />
          <img src={require("../../assets/images/backSlash.png")} alt="" />
          <div className="flex flex-col">
            <span className="flex flex-row">
              <AnimatedCounter className="p-2" endValue={120} />
              &nbsp;+
            </span>
            <div className="text-sm opacity-60">CUSTOMERS</div>
          </div>
        </div>
        <div className="text-white flex flex-row items-center ">
          <EmojiEvents sx={{ fontSize: { md: "60px", sm: "40px" } }} />
          <img src={require("../../assets/images/backSlash.png")} alt="" />
          <div className="flex flex-col">
            <span className="flex flex-row">
              <AnimatedCounter className="p-2" endValue={3} />
            </span>
            <div className="text-sm opacity-60">AWARDS</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StatsBanner;
